
import { useRef, useState } from 'react'
import './pdf.css'
import { useParams } from 'react-router-dom'
import { QueryGetImovel } from '../../graphql/services'
import { Loader } from '../../components/UI/Loader/Loader'

import MeuImovelReport from '../../components/Reports/MeuImovel'
import { CoordinatesToPath } from '../../components/UI/MapStatic'
import * as turf from '@turf/turf'
import { MapboxLayer } from '../../components/UI/Mapbox/MapboxLayer'
import html2canvas from 'html2canvas'

type Props = {
  closeModal: any
}

export function ExportPdf({ closeModal }: Props) {
  const {id: idTerreno} = useParams<{id: string}>()
  const [mapImage, setMapImage] = useState(null)
  const mapRef = useRef()
  const {data} = QueryGetImovel({ variables: { getImovelId: parseInt(idTerreno) } })

  if (!data) {
    return <Loader text='Carregando'></Loader>
  }

  const latlng = []
  if (data.GetImovel.marcacao) {
    latlng.push({
      path: CoordinatesToPath(data.GetImovel.marcacao['coordinates'][0][0]),
      center: turf.centroid(data.GetImovel.marcacao),
      id: data.GetImovel.id,
      endereco: data.GetImovel.endereco,
      area: data.GetImovel.area_iptu,
      editable: false,
    })
  }

  // async function handlePrint() {
  //   const img = await exportAsImage(exportRef.current, 'test')
  //   // setPrint(img)
  // }
  function onload(image) {
    // const features: any[] = []
    // eslint-disable-next-line array-callback-return
    // dataImoveis.GetEmpreendimentoImovel.map((imoveis) => {
    //   features.push({type: 'Feature', geometry: imoveis.terreno.marcacao, properties: {}})
    // })

    html2canvas(image.target.getCanvasContainer(), {useCORS: true, width: 600, height: 350}).then(
      (canvas) => {
        let map1Image = canvas.toDataURL('image/png', 1.0)
        setMapImage(map1Image)
      }
    )
  }
  return (
    <>
      <div style={{width: "148rem"}}>


      <div className='col-md-12' style={{height:'auto', width:'100%'}}>
      <div style={{position: 'fixed', top: 0,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 zIndex: -1}}>
      {!mapImage ?  <MapboxLayer
              latLng={[data.GetImovel.latitude, data.GetImovel.longitude]}
              inputRef={mapRef}
              onLoad={(map) => {onload(map)}}
              options={{
                tiles: ['https://tile.urbit.com.br/tile/view_explorer_lotes_acessoria/{z}/{x}/{y}.pbf?s=sao_paulo'],
                source: 'view_explorer_lotes_acessoria',
                paint: {'fill-color': '#d0d0d0','fill-outline-color': '#000', 'fill-opacity': 0.2},
                layout:{
                  'text-field': ['get', 'endereco'], // Nome do atributo com o texto
                  'text-size': 12, // Tamanho do texto
                  'text-anchor': 'top', // Âncora do texto (pode ser 'top', 'bottom', 'center', etc.)
                },
                paintText:{
                  'text-color': '#000000', // Cor do texto
                }
              }}
              zoom={19}
            ></MapboxLayer> :<></>}        </div>
        </div>
        {/* <MapToPrint
          latLng={latlng}
          onChange={() => { }}
          id={'maptoprint'}
          ref={exportRef}
          data={data}
        ></MapToPrint> */}
       {mapImage ?  <MeuImovelReport data={data} map={mapImage}></MeuImovelReport> :(
          <div className='overlay loading'>
            <div className='loading-fullscreen'>Carregando mapa...</div>
          </div>
        )}
      </div>
    </>
  )
}